import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { Subject, take, takeUntil } from 'rxjs';

import { FocusableComponent } from '../focusable';
import { TextComponent } from '../text';

@Component({
  selector: 'vi-ui-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LinkComponent extends FocusableComponent implements OnDestroy {
  @Input() text: string;
  @Input() href: string;
  @Input() role: string = 'link';
  @Input() target: string = '_blank';
  @Input() size: TextComponent['size'] = '14-20';
  @Input() inline?: boolean = false;
  @Input() iconClass?: string;
  @Input() iconColor: string = 'var(--primary)';
  @Input() color: string = 'var(--primary)';
  @Input() hoverColor: string = 'var(--primary-hover';
  @Input() activeColor: string = 'var(--primary-press)';
  @Input() highContrast?: boolean = false;
  @Input() withTruncate?: boolean = false;
  @Input() highContrastColor?: string = 'var(--primary-press)';
  @Input() highContrastHoverColor?: string;
  @Input() highContrastActiveColor?: string;
  @Output() linkClicked = new EventEmitter<string>();

  private destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {
    super();
    this.accessibilityModeSubject.pipe(takeUntil(this.destroy$), take(1)).subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public get linkColorStyle(): { '--default-color': string; '--hover-color': string; '--active-color': string } {
    return {
      '--default-color': this.highContrast ? this.highContrastColor || this.color : this.color,
      '--hover-color': this.highContrast ? this.highContrastHoverColor || this.hoverColor : this.hoverColor,
      '--active-color': this.highContrast ? this.highContrastActiveColor || this.activeColor : this.activeColor
    };
  }
}
